/* eslint no-undef: 0 */

// We use a cdn to speed up asset delivery and cache old chunks
// We're only using it for assets because switching DNS to the cdn is a huge pain
// https://medium.com/pixel-and-ink/serving-webpack-assets-from-a-different-domain-c649d0925d7a
__webpack_public_path__ =
  process.env.USE_CDN === "true" ? "https://cdn.consigncloud.com/" : window.location.origin + "/"

import "font-awesome/css/font-awesome.css"
import "spinkit/css/spinners/7-three-bounce.css"
import "animate.css/animate.min.css"
import "tippy.js/dist/tippy.css"
import "resources/css/tailwind.css"
import "resources/css/style.css"

import React from "react"
import ReactDOM from "react-dom"
import {Router} from "react-router-dom"
import {Provider} from "react-redux"
import history from "utils/history"
import {makeStore, getShellReducers} from "app/state"
import "app/core/client"
import Shell from "app/main/Shell"

ReactDOM.render(
  <Provider store={makeStore(getShellReducers())}>
    <Router history={history}>
      <Shell />
    </Router>
  </Provider>,
  document.getElementById("root"),
)
